import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter, HashRouter, Route, Routes } from 'react-router-dom';
import EmanuelPressPage from './pages/press/emanuelpage';
import AnalyticsGate from './components/AnalyticsGate';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AnalyticsGate>
      <HashRouter>
        <Routes>
          {/* Regular route for the /press page */}
          <Route path="/pressmeddelanden/emanuel-lipschutz-styrelseordforande-acebit" element={<EmanuelPressPage />} />
          {/* Catch-all route for the rest of the app */}
          <Route path="/*" element={<App />} />
        </Routes>
      </HashRouter>
    </AnalyticsGate>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();